export const STORES_PENDING = 'STORES_PENDING';
export const STORES_REJECTED = 'STORES_REJECTED';
export const FETCH_STORES_FULFILLED = 'FETCH_STORES_FULFILLED';
export const SET_STORE = 'SET_STORE';


// WEBPACK FOOTER //
// ./src/constants/stores.js